import type { McqAnswer, Question } from '../types/models';

interface Props {
  question: Question;
  value: McqAnswer;
  onChange: (next: McqAnswer) => void;
  disabled?: boolean;
}

export function McqEditor({ question, value, onChange, disabled = false }: Props) {
  const multi = question.type === 'MultipleChoiceMulti';
  const selected = new Set(value.selectedOptionIds);

  function toggle(id: string) {
    if (disabled) return;
    if (multi) {
      const next = new Set(selected);
      next.has(id) ? next.delete(id) : next.add(id);
      onChange({ kind: 'mcq', selectedOptionIds: [...next] });
    } else {
      // Single choice: selecting always sets exactly this option. A selected radio can never be
      // cleared by clicking it again — once chosen, an answer stays chosen (it can only change).
      onChange({ kind: 'mcq', selectedOptionIds: [id] });
    }
  }

  return (
    <div>
      {multi && <div className="muted" style={{ marginBottom: 8 }}>Select all that apply.</div>}
      {question.options.map(o => (
        <div
          key={o.id}
          className={`mcq-option ${selected.has(o.id) ? 'selected' : ''}`}
          onClick={() => toggle(o.id)}
          style={disabled ? { cursor: 'not-allowed', opacity: 0.6 } : undefined}
        >
          <input
            type={multi ? 'checkbox' : 'radio'}
            checked={selected.has(o.id)}
            onChange={() => toggle(o.id)}
            disabled={disabled}
            style={{ width: 'auto', marginTop: 2 }}
          />
          <span>{o.text}</span>
        </div>
      ))}
    </div>
  );
}
